/**
 * The roster's Pinned group key stays `pinned` for one space and becomes
 * `space:<id>:pinned` when several spaces share the sidebar. Pinned bots are
 * also excluded from every other group, so a tile never repeats below.
 */
export function isPinnedSidebarGroupKey(key: string): boolean {
  // Section keys can end in `pinned` when a user names a section id that way.
  if (key.includes("section:")) return false;
  return key === "pinned" || key.endsWith(":pinned");
}

/** Pinned tiles keep the server's order; dedupe only a repeated bot/group id. */
export function pinnedTileItems<T extends { kind: string; chat: { id: string } }>(
  items: readonly T[],
): T[] {
  const seen = new Set<string>();
  const unique: T[] = [];
  for (const item of items) {
    const key = `${item.kind}:${item.chat.id}`;
    if (seen.has(key)) continue;
    seen.add(key);
    unique.push(item);
  }
  return unique;
}
